import { Link } from 'react-router-dom';  
import styled from 'styled-components';    
  
export const Container = styled.div`    
  display: flex;    
  flex-direction: row;    
  justify-content: space-between;    
  align-items: flex-start; // 追加   
    
  @media (max-width: 1000px) {    
    flex-direction: column;    
  }    
`;    
    
export const Half = styled.div`    
  width: 50%;    
  display: flex;      // 追加  
  justify-content: center; // 追加    
    
  @media (max-width: 1000px) {    
    width: 100%;    
  }    
`;    
  
export const ImageContainer = styled.div`    
  display: flex;    
  flex-direction: column;    
  align-items: center;    
  justify-content: center;    
  width: 100%;    
`;    
  
export const StyledImage = styled.img`    
  max-width: 100%;  // 追加    
  height: auto;  // 追加    
`;    
  
export const BoldLink = styled(Link)`    
  font-weight: bold;    
`;  
